<template>
  <div class="main_box">
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            {{ questionGroupInfo.Name }}
          </div>
        </div>
        <div class="form_bar_btn">
          <div class="condition_item">
            <el-button @click="openQuestionGroupManager()"> 返回 </el-button>
            <el-button type="primary" @click="editQuestion(null)">
              新增题目
            </el-button>
          </div>
          <div class="condition_item" v-show="false">
            <el-button type="primary" @click="exportTemplate()">
              导出Excel模板
            </el-button>
            <el-button type="primary" @click="importData()">
              导入数据
            </el-button>
          </div>
        </div>
      </div>
      <el-table :data="questionList" style="width: 100%" stripe>
        <el-table-column label="序号" width="60">
          <template slot-scope="scope" style="vertical-align: top">
            <p>
              {{ listQuery.skipCount + scope.$index + 1 }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="题目">
          <template slot-scope="scope">
            <div v-html="scope.row.QuestionStem"></div>
          </template>
        </el-table-column>
        <el-table-column
          property="QuestionTypeText"
          label="题型"
          align="center"
          width="70"
        >
        </el-table-column>
        <el-table-column
          property="Score"
          label="分值"
          align="center"
          width="70"
        >
        </el-table-column>
        <el-table-column label="显示顺序" width="70" align="center" key="Sort">
          <template slot-scope="scope">
            <span>{{ scope.row.Sort }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="editQuestion(scope.row.Id)"
            >
              编辑
            </el-link>
            <el-link
              type="primary"
              class="cell_link"
              @click.stop
              @click="deleteQuestion(scope.row)"
            >
              删除
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination_box">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="listQuery.MaxResultCount"
          :layout="pagination_layout"
          :total="listTotalCount"
        >
        </el-pagination>
      </div>
      <EditQuestion
        :QuestionGroupId="questionGroupId"
        :MeetingID="meetingId"
        :fatherSubmitDialog="editQuestionDialog"
        ref="editQuestion"
      ></EditQuestion>
    </div>
  </div>
</template>
<script>
import questionGroupApi from '../../../../api/wj/questionGroup.js'
import questionApi from '../../../../api/wj/question.js'
import EditQuestion from '@/components/wj_question/EditQuestion.vue'
export default {
  name: 'questionManage',
  components: {
    EditQuestion
  },
  data () {
    return {
      meetingId: null,
      questionGroupId: null,
      questionList: [],
      listTotalCount: 0,
      currentPage: 1,
      listQuery: {
        GroupId: null,
        maxResultCount: 10,
        skipCount: 0
      },
      questionGroupInfo: {},
      pagination_layout: 'prev, pager, next'
    }
  },
  methods: {
    getQuestionGroup: function () {
      this.openLoading()
      questionGroupApi.getQuestionGroup({
        questionGroupId: this.questionGroupId
      }).then(data => {
        this.questionGroupInfo = data
        this.getQuestions()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    getQuestions: function () {
      this.openLoading()
      questionApi.getQuestions(this.listQuery).then(data => {
        this.questionList = data.Items
        this.listTotalCount = data.TotalCount
        this.openLoading().close()
      }).catch(err => {
        this.openLoading().close()
        return err
      })
    },
    handleSizeChange (val) {
      this.listQuery.maxResultCount = val
      this.getQuestions()
    },
    handleCurrentChange (val) {
      this.listQuery.skipCount = (val - 1) * this.listQuery.maxResultCount
      this.getQuestions()
    },
    deleteQuestion: function (item) {
      this.$confirm('确认删除该题目吗？' + item.QuestionStem, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box',
        dangerouslyUseHTMLString: true
      }).then(() => {
        const openLoading = this.openLoading('删除中…')
        questionApi.deleteQuestion({
          questionId: item.Id
        }).then(data => {
          openLoading.close()
          this.getQuestions()
          this.$message({
            type: 'success',
            message: '删除成功!',
            customClass: 'custom_message'
          })
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
          customClass: 'custom_message'
        })
      })
    },
    editQuestion: function (questionId) {
      this.$refs.editQuestion.openEditQuestion(questionId)
    },
    editQuestionDialog: function () {
      this.getQuestions()
    },
    openQuestionGroupManager: function () {
      this.$router.push({ name: 'questionBankManage', params: { cid: this.$route.params.cid, mid: this.$route.params.mid } })
    },
    indexMethod (index) {
      return this.listQuery.skipCount + index + 1
    },
    exportTemplate: function () {
      const openLoading = this.openLoading('正在导出…')
      questionApi.exportQuestionTemplate({
        MeetingId: this.$route.params.mid,
        QuestionGroupId: this.questionGroupId
      }).then(data => {
        if (!data) {
          return
        }
        let fileName = '题目'
        if (this.questionGroupId) {
          fileName = this.questionGroupInfo.Name
        }
        const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

        const elink = document.createElement('a')
        // 设置下载文件名
        elink.setAttribute('download', fileName + '.xlsx')
        elink.style.display = 'none'
        elink.href = fileUrl
        document.body.appendChild(elink)
        elink.click()

        document.body.removeChild(elink) // 下载完成移除元素
        window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    importData: function () {
      this.$refs.importQuestion.openImportExcel(this.questionGroupId, this.$route.params.mid)
    },
    importExcelDialog: function (questionGroupId) {
      this.$router.push({ name: 'questionManage', params: { cid: this.$route.params.cid, mid: this.$route.params.mid, gid: questionGroupId } })
      this.init()
    },
    init: function () {
      this.meetingId = this.$route.params.mid
      this.questionGroupId = this.$route.params.gid
      this.listQuery.GroupId = this.$route.params.gid
      this.getQuestionGroup()
    }
  },
  computed: {

  },
  created () {
    this.init()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
</style>
